import axios from 'axios'
import FormData from 'form-data'

export const GET_MODEL_LIST = '@viewer/get-model-list'
export const GET_MODEL_LIST_SUCCESS = '@account/get-model-list-success'
export const GET_MODEL_LIST_FAILURE = '@account/get-model-list-failure'
export const UPLOAD_MODEL = '@account/upload-model'
export const UPLOAD_MODEL_SUCCESS = '@account/upload-model-success'
export const UPLOAD_MODEL_FAILURE = '@account/upload-model-failure'
export const SET_DEFAULT = '@account/set-default'
export const SET_UPLOADED_FILE_INFO = '@account/set-uploaded-file-info'

export function getModelList () {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_MODEL_LIST })
      await axios
        .get('/models')
        .then(async (response) => {
          console.log('model data is ===', response.data)
          await dispatch({
            type: GET_MODEL_LIST_SUCCESS,
            payload: response.data
          })
        })
    } catch (error) {
      dispatch({
        type: GET_MODEL_LIST_FAILURE
      })
      throw error
    }
  }
}

export function uploadNewModel (files) {
  return async (dispatch) => {
    try {
      dispatch({ type: UPLOAD_MODEL })
      const data = new FormData()
      files.forEach((file, index) => {
        data.append(`file${index}`, file)
      })

      console.log('form data ===', data)

      await axios
        .post('/upload/', data)
        .then(async (response) => {
          await dispatch({
            type: UPLOAD_MODEL_SUCCESS,
            payload: response.data,
            loading: false
          })
        })
    } catch (error) {
      dispatch({
        type: UPLOAD_MODEL_FAILURE
      })
      throw error
    }
  }
}

export function setDefault () {
  return async (dispatch) => {
    // eslint-disable-next-line no-useless-catch
    try {
      dispatch({ type: SET_DEFAULT })
    } catch (error) {
      throw error
    }
  }
}

export function setUploadedFileInfo (model, index) {
  return async (dispatch) => {
    // eslint-disable-next-line no-useless-catch
    try {
      dispatch({
        type: SET_UPLOADED_FILE_INFO,
        payload: model,
        index
      })
    } catch (error) {
      throw error
    }
  }
}
